import React, { Component } from 'react';
import { connect } from 'react-redux';
import config from '../../config/config';
import './termsMessage.css';

class TermsMessage extends Component {
    render() {
        const { stepInfo } = this.props;

        // Only show for specific companies
        if (!stepInfo?.company_id || !config.directCustomerServiceCompaniesIds.includes(stepInfo.company_id)) {
            return null;
        }

        return (
            <p className="terms-message">
                Al continuar estás aceptando los{' '}
                <a 
                    href="https://static.retail.autofact.cl/documentos/terminos-y-condiciones-servicio-transferencia.pdf" 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="terms-message__link"
                >
                    Términos y Condiciones
                </a>.
            </p>
        );
    }
}

const mapStateToProps = state => {
    return {
        stepInfo: state.stepInfo
    };
};

export default connect(mapStateToProps)(TermsMessage);

